import {getPropValue, isObject} from "@spoferan/spoferan-ts-core";
import ParsesErrorMessages from "./ParsesErrorMessages.mjs";

export default {
    mixins: [ParsesErrorMessages],

    emits: ['success', 'error'],

    methods: {

        /**
         * Handles a successful response from the server.
         *
         * @param response
         */
        handleSuccess(response) {

            if (response.redirect) {
                window.location.href = response.redirect
                return;
            }

            const alert = response.alert
            const notification = response.notification

            // Check if the user shall be authenticated with the response
            if (this.$auth && !this.$auth.loggedIn && response.login && response.login.token) {
                this.$auth.setUserToken(response.login.token);
            }

            // Display an alert
            const params = {};
            if (this.langParams) {
                Object.keys(this.langParams).forEach(langKey => {
                    const responseKey = this.langParams[langKey];
                    const responseValue = getPropValue(response.data, responseKey)

                    params[langKey] = responseValue !== undefined ? responseValue : responseKey;
                })
            }

            if (this.withoutFeedback) {
                this.$emit('success', response.data, response)
            } else if (alert) {
                this.$alert({
                    title: alert.title,
                    text: alert.message,
                    type: alert.type ? alert.type : 'success',
                    confirmText: alert.accept ? alert.accept : 'Ok'
                }).then(() => {
                    this.$emit('success', response.data, response)
                })
            } else if (this.alert) {
                this.$alert({
                    title: this.$t(`alert.${this.alert}.title`),
                    text: this.$t(`alert.${this.alert}.message`, params),
                    type: 'success',
                    confirmText: this.$t('alert.default.' + this.method.toLowerCase() + '.accept')
                }).then(() => {
                    this.$emit('success', response.data, response)
                })
            } else if (notification) {
                this.$notify(notification.type ? notification.type : 'success', notification.message, notification.title, notification.duration ? notification.duration : 4500)
                this.$emit('success', response.data, response)
            } else if (this.notification || this.notification === '') {
                if (this.notification === true || this.notification === '') {
                    this.$notify('success', this.$t('notification.saved.message'))
                } else if (this.notification !== false) {
                    const titleKey = `notification.${this.notification}.title`;
                    const title = this.$t(titleKey);
                    this.$notify('success', this.$t(`notification.${this.notification}.message`, params), title === titleKey ? null : title)
                }
                this.$emit('success', response.data, response)
            } else {
                this.$emit('success', response.data, response)
            }

            this.onSuccess(response.data);
        },

        /**
         * Gets called when the form was successfully submitted and a successful response was retrieved from the server.
         */
        onSuccess() {

        },

        /**
         * Handles an error response from the server.
         *
         * @param error
         */
        handleError(error) {
            if (!error || !error.statusCode) {
                const defaultError = {
                    message: this.$t('error.unknown')
                };

                this.showServerErrorAlert(500, defaultError, () => {
                    this.$emit('error', 500, defaultError)
                });
                return;
            }

            const status = error.statusCode;
            if (status === 422 && error.errors) {
                this.handleFailedValidation(error.errors)
                this.$emit('error', status, error)
            } else {
                this.showServerErrorAlert(status, error, () => {
                    this.$emit('error', status, error)
                })
            }
        },

        showServerErrorAlert(status, errorResponse, callback) {
            const notificationStatusCodes = [422];
            const showAsNotification = (status && notificationStatusCodes.includes(status)) || (errorResponse && errorResponse.notification);
            const defaultMessage = errorResponse.display_message ?? (errorResponse.message ?? (errorResponse.error ?? this.$t('error.unknown')));

            if (showAsNotification) {
                const notificationData = errorResponse && errorResponse.notification ? errorResponse.notification : {};
                const title = notificationData.title ? notificationData.title : this.getErrorTitleByStatus(status);
                const message = notificationData.message ? notificationData.message : defaultMessage;
                const type = notificationData.type ? notificationData.type : 'error';
                const duration = notificationData.duration ? notificationData.duration : 4500;
                this.$notify(type, message, title, duration)
                callback()
            } else {
                const alertData = errorResponse && errorResponse.alert ? errorResponse.alert : {};
                const title = alertData.title ? alertData.title : this.getErrorTitleByStatus(status);
                const message = alertData.message ? alertData.message : defaultMessage;
                const type = alertData.type ? alertData.type : this.getErrorTypeByStatus(status);
                const confirmText = alertData.accept ? alertData.accept : 'Ok';
                this.$alert({
                    title: title,
                    text: message,
                    type: type,
                    confirmText: confirmText
                }).then(() => {
                    callback()
                })
            }
        },

        getErrorTitleByStatus(errorStatus) {
            switch (errorStatus) {
                case 422:
                    return this.$t('validation.check_inputs');
            }

            return 'Whoops!';
        },

        getErrorTypeByStatus(errorStatus) {
            return errorStatus >= 400 && errorStatus <= 499 ? 'warning' : 'error';
        },

        /**
         * Handles a failed validation check of the form.
         *
         * @param failedFields
         */
        handleFailedValidation(failedFields) {
            if (failedFields && Object.keys(failedFields).length) {
                const failedValidation = failedFields[Object.keys(failedFields)[0]][0]
                const message = isObject(failedValidation) ? failedValidation.message : failedValidation
                this.$notify('error', message, this.$t('validation.check_inputs'))
            }
        }
    }
}

